export function isError(data) {
    return data instanceof Error;
}
